export const config = {
    BASE_URL: process.env.REACT_APP_API_URL || 'https://api.emdsoftwares.com/api/v1/',
    // BASE_URL: process.env.REACT_APP_API_URL || 'https://emds-be-149372500714.us-west1.run.app/api/v1/',
    // BASE_URL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api/v1/',
}
